import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import css from '../css/form.m.css';
let FormLabel = class FormLabel extends I18nThemed {
    render() {
        const { title } = this.properties;
        return v('div', { classes: [this.theme(css.formLabel)] }, [v('label', {}, [title])]);
    }
};
FormLabel = __decorate([
    theme(css)
], FormLabel);
export { FormLabel };
